import { Box } from '@mui/material';
import { fCurrency } from '../../../../../../utils/formatNumber';
import ConfirmSubmitDialog from './ConfirmSubmitDialog';
import { useConfirmDialog } from '../../../../../../hooks/useConfirmDialog';

function getMismatchMessage({
  creditMemoMismatch,
  invoiceTypeMismatch,
  shippingMismatch,
  totalMismatch,
  calculatedTotal,
  glsShippingTotal,
  invoice,
}) {
  if (creditMemoMismatch) {
    return `This invoice is marked as a "Credit Memo", but the total is positive: ${fCurrency(
      calculatedTotal
    )}. Credit Memos should have negative totals.`;
  }
  if (invoiceTypeMismatch) {
    return (
      <>
        <Box>This invoice is marked as "Invoice", but the total is negative: ${fCurrency(calculatedTotal)}.</Box>
        <Box>Regular invoices should have positive totals.</Box>
        <Box>Consider changing it to a "Credit Memo" if applicable.</Box>
      </>
    );
  }
  if (shippingMismatch) {
    return `Shipping: ${fCurrency(glsShippingTotal)} doesn't match the vendor's shipping total: ${fCurrency(
      invoice.shipping
    )}. Please correct it in the GL Codes section.`;
  }
  if (totalMismatch) {
    return `Total: ${fCurrency(invoice?.total)} doesn't match the GLs total: ${fCurrency(calculatedTotal)}`;
  }
  return '';
}

export function useMismatchNotification(mismatch, onConfirm) {
  const dialog = useConfirmDialog();
  const hasMismatch =
    mismatch.creditMemoMismatch || mismatch.invoiceTypeMismatch || mismatch.totalMismatch || mismatch.shippingMismatch;

  const element = dialog.isOpen ? (
    <ConfirmSubmitDialog
      title="Review Needed"
      content={getMismatchMessage(mismatch)}
      handleCloseSubmitDialog={dialog.close}
      onConfirmSubmit={onConfirm}
    />
  ) : null;

  return { hasMismatch, open: dialog.open, element };
}